import React, { useEffect } from "react";
import { Table, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchPatientDetails } from "../../Redux/Slice/Doctor/Patients";

const PatientReports = () => {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));
  const patientId = user?.patientId;

  const { data, loading } = useSelector(
    (state) => state.patient.patientDetails
  );

  useEffect(() => {
    if (patientId) dispatch(fetchPatientDetails(patientId));
  }, [dispatch, patientId]);
  const prescriptions = data?.data?.[0]?.prescriptions || [];
  const prescriptionPdfs = data?.data?.[0]?.prescriptionPdfs || [];
  const labReports = data?.data?.[0]?.labReports || [];
  const radReports = data?.data?.[0]?.radReports || [];

  const prescriptionColumns = [
    { title: "Date", dataIndex: "createdOn", key: "createdOn" },
    { title: "Medicine", dataIndex: "medicineName", key: "medicineName" },
    { title: "Dosage", dataIndex: "dosage", key: "dosage" },
    { title: "Qty", dataIndex: "quantity", key: "quantity" },
    { title: "Frequency", dataIndex: "frequency", key: "frequency" },
    {
      title: "Food Instruction",
      dataIndex: "foodInstruction",
      key: "foodInstruction",
    },
  ];

  const reportColumns = [
    { title: "Date", dataIndex: "createdOn", key: "createdOn" },
    { title: "Test Name", dataIndex: "testName", key: "testName" },
    {
      title: "Report",
      render: (_, record) => (
        <a href={record.reportUrl} target="_blank" rel="noreferrer">
          {record.fileName}
        </a>
      ),
    },
  ];

  const pdfColumns = [
    { title: "Date", dataIndex: "createdOn", key: "createdOn" },
    {
      title: "Prescription PDF",
      render: (_, record) => (
        <a href={record.pdfUrl} target="_blank" rel="noreferrer">
          View PDF
        </a>
      ),
    },
  ];

  // const handleView = (record) => {
  //   setSelectedRecord(record);
  //   setModalVisible(true);
  // };

  // const handleUpload = (file) => {
  //   const newRecord = {
  //     key: records.length + 1,
  //     date: new Date().toISOString().split("T")[0],
  //     type: "Uploaded Document",
  //     doctor: "Self Upload",
  //     notes: "Uploaded by patient",
  //     document: file.name,
  //   };
  //   setRecords([...records, newRecord]);
  //   message.success(`${file.name} uploaded successfully`);
  //   return false; // Prevent auto-upload
  // };

  return (
    <div>
      <h2>Patient Reports</h2>
      {/* 
      <Upload beforeUpload={handleUpload} showUploadList={false}>
        <Button type="dashed" icon={<UploadOutlined />}>
          Upload Document
        </Button>
      </Upload> */}

      <Tabs defaultActiveKey="prescriptions">
        <Tabs.TabPane tab="Prescriptions" key="prescriptions">
          <Table
            columns={prescriptionColumns}
            dataSource={[...prescriptions].reverse()}
            rowKey="createdOn"
            pagination={false}
            loading={loading}
          />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Prescription PDFs" key="pdfs">
          <Table
            columns={pdfColumns}
            dataSource={[...prescriptionPdfs].reverse()}
            rowKey="createdOn"
            pagination={false}
            loading={loading}
          />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Lab Reports" key="lab">
          <Table
            columns={reportColumns}
            dataSource={[...labReports].reverse()}
            rowKey="createdOn"
            pagination={false}
            loading={loading}
          />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Radiology Reports" key="radiology">
          <Table
            columns={reportColumns}
            dataSource={[...radReports].reverse()}
            rowKey="createdOn"
            pagination={false}
            loading={loading}
          />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default PatientReports;
